<template>
  <i18n-t keypath="app.required-fields-hint" tag="p">
    <template #star><span class="text-primary">*</span></template>
  </i18n-t>
</template>

<script lang="ts" setup>
</script>
